export default __webpack_public_path__ + "98069ce88f63a2ea7a1a2ff1cc1a2b91.jpg";